import React, { useCallback, useEffect, useState } from "react";
import "./rememberTheNumber.scss";
import TestFooter from "../testFooter/testFooter";
import { HelperContext } from "../../store/helperStore";
import { AnswerContext } from "../../store/answerStore";
import useTimer from "../../Hooks/useTimer";
import { answeredQues } from "../../helper/testHelper";
import { message } from "antd";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { getStudentData } from "../../helper/localStorage";
import { addTestResult } from "../../api/addTestResult";

const getRandomRotation = () => {
  const randomNum = Math.random();
  return randomNum < 0.5
    ? Math.floor(Math.random() * 46) // 0 to 45 degrees
    : Math.floor(Math.random() * 46) + 315; // 315 to 360 degrees
};

const getRandomFlexBasis = () => {
  return `${Math.floor(Math.random() * (30 - 20 + 1) + 20)}%`; // 20% to 30%
};

const grade_id = JSON.parse(localStorage.getItem("gradeId"));
const { login_id } = getStudentData();

const RememberTheNumber = ({ question, questions, index }) => {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();

  const [userInput, setUserInput] = useState([]);
  const { pause, reset, start, time } = useTimer();
  const ansArr = question.correct_text?.split(",");
  const { isNextQues, showingNumbers } = helperC;
  const [rotations, setRotations] = useState([]);
  const [basis, setBasis] = useState([]);

  const handleUserInput = (input) => {
    if (userInput.includes(input)) {
      setUserInput((prev) => {
        const newArr = [...prev];
        const inputIndex = newArr.findIndex((value) => value === input);
        newArr.splice(inputIndex, 1);
        return newArr;
      });
      return;
    }
    if (userInput.length >= ansArr.length) {
      message.destroy();
      message.error({
        content: "You cannot select more that 9 numbers",
      });
      return;
    }
    setUserInput((prev) => [...prev, input]);
  };

  const handleNext = useCallback(() => {
    const nextTest = questions[index + 1];
    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: answeredQues("remember_the_numbers", userInput, question, time),
    });
    if (index < questions.length - 1) {
      reset();
      start();
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: nextTest.id,
      });
    } else {
      const answerRes = [...answerC.answers];
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions,
        false //is reaction test
      );
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes, // Use the updated answers here
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
  }, [questions, index, dispatchAnswer, userInput, question, time, reset, start, dispatchHelper, answerC.answers]);

  useEffect(() => {
    if (isNextQues) {
      handleNext();
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    }
  }, [dispatchHelper, handleNext, isNextQues]);

  useEffect(() => {
    dispatchHelper({
      type: "SHOWING_NUMBERS",
      payload: true,
    });
    start();

    // Generate random rotations and basis for each new question
    setRotations(ansArr.map(() => getRandomRotation()));
    setBasis(ansArr.map(() => getRandomFlexBasis()));
  }, [question]);

  useEffect(() => {
    if (showingNumbers) {
      if (time >= 20) {
        dispatchHelper({
          type: "SHOWING_NUMBERS",
          payload: false,
        });
        reset();
        start();
      }
    }
  }, [dispatchHelper, reset, showingNumbers, start, time]);

  return (
    <div className="rem-flex">
      <div className="test-header rev-question">{showingNumbers ? question.que_title1 : "Tap all the digits you remember from last screen"}</div>
      {showingNumbers ? (
        <div className="rem-question-box">
          {ansArr.map((item, index) => {
            return (
              <div
                className="rem-box"
                style={{
                  transform: `rotate(${rotations[index]}deg)`,
                  flexBasis: basis[index],
                }}
                key={index}
              >
                {item}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="rem-buttons-container">
          {question.que_title2.map((item, index) => {
            return (
              <button
                key={index}
                className={`button ${
                  userInput.includes(item) ? "selected" : ""
                }`.trim()}
                onClick={() => handleUserInput(item)}
              >
                {item}
              </button>
            );
          })}
        </div>
      )}
      <TestFooter
        index={index}
        question={question}
        questions={questions}
        isUserInput={userInput.length === ansArr.length}
      />
    </div>
  );
};

export default RememberTheNumber;
